<template>
  <v-card>
    <v-toolbar color="indigo" dark dense>
      <!-- buttons for mobile -->
      <template v-slot:extension v-if="$vuetify.breakpoint.xsOnly">

        <tooltip-basic v-if="debugMode" :text="'$vuetify.sqlHelperDialog.title'" :icon="sqlIcon"
                       :emit-state="`sql-helper-dialog`"
                       @sql-helper-dialog="sqlHelperDialog = true"></tooltip-basic>

        <tooltip-basic :text="'$vuetify.map.travelStatsCard.clientFilesDialogButton'" :icon="clientFilesIcon"
                       :emit-state="`client-files-dialog`"
                       @client-files-dialog="clientFilesDialog = true"></tooltip-basic>

        <template
          v-if="tab === 0 && travel.isTravelExists() && !travel.isFeedbackExists()">
          <user-feedback-form @feedback-processed="passFeedback" type="local" :user-id="travel.user.userId"
                              :travel-datetimestart="travel.datetimestart.getTime()"></user-feedback-form>
        </template>

        <v-tooltip top v-if="isSpecial">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="loadAdditionalStatistics" :disabled="isLoading">
              <v-icon>{{ loadIcon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.t('$vuetify.map.mapDialog.tripAdditionalStatisticsLabel') }}</span>
        </v-tooltip>

        <text-copy-popup :travel-id="travel.travelId"
                         v-if="tab === 0 && travel.isTravelExists()"></text-copy-popup>

        <user-feedback-form v-if="tab === 1 && travel.isTravelExists()"
                            :mode="ComponentMode.EDIT"
                            type="local"
                            :travel-datetimestart="travel.datetimestart.getTime()"
                            :user-id="travel.user.userId"
                            :drowsiness="travel.drowsinessFeedback.feedback"
                            :aggressiveness="Boolean(travel.aggressivenessFeedback.feedback)"
                            @feedback-processed="passFeedback"
        ></user-feedback-form>

        <tooltip-basic v-if="isAdmin"
                       :text="'$vuetify.map.travelStatsCard.measurementsDialogButton'" :icon="measurementsIcon"
                       :emit-state="`measurements-dialog`"
                       @measurements-dialog="measurementsDialog = true"></tooltip-basic>
      </template>

      <v-toolbar-title>
        <v-icon left v-if="!$vuetify.breakpoint.xsOnly">{{ barIcon }}</v-icon>
        {{ $vuetify.lang.t('$vuetify.map.travelStatsCard.title') }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="!$vuetify.breakpoint.xsOnly">
        <!-- desktop on the same line as toolbar title -->

        <tooltip-basic v-if="debugMode" :text="'$vuetify.sqlHelperDialog.title'" :icon="sqlIcon"
                       :emit-state="`sql-helper-dialog`"
                       @sql-helper-dialog="sqlHelperDialog = true"></tooltip-basic>

        <tooltip-basic :text="'$vuetify.map.travelStatsCard.clientFilesDialogButton'" :icon="clientFilesIcon"
                       :emit-state="`client-files-dialog`"
                       @client-files-dialog="clientFilesDialog = true"></tooltip-basic>

        <template
          v-if="tab === 0 && travel.isTravelExists() && !travel.isFeedbackExists()">
          <user-feedback-form @feedback-processed="passFeedback" type="local" :user-id="travel.user.userId"
                              :travel-datetimestart="travel.datetimestart.getTime()"></user-feedback-form>
        </template>

        <v-tooltip top v-if="isSpecial">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="loadAdditionalStatistics" :disabled="isLoading">
              <v-icon>{{ loadIcon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.t('$vuetify.map.mapDialog.tripAdditionalStatisticsLabel') }}</span>
        </v-tooltip>

        <text-copy-popup :travel-id="travel.travelId"
                         v-if="tab === 0 && travel.isTravelExists()"></text-copy-popup>

        <user-feedback-form v-if="tab === 1 && travel.isTravelExists()"
                            :mode="ComponentMode.EDIT"
                            type="local"
                            :travel-datetimestart="travel.datetimestart.getTime()"
                            :user-id="travel.user.userId"
                            :drowsiness="travel.drowsinessFeedback.feedback"
                            :aggressiveness="Boolean(travel.aggressivenessFeedback.feedback)"
                            @feedback-processed="passFeedback"
        ></user-feedback-form>

        <tooltip-basic v-if="isAdmin"
                       :text="'$vuetify.map.travelStatsCard.measurementsDialogButton'" :icon="measurementsIcon"
                       :emit-state="`measurements-dialog`"
                       @measurements-dialog="measurementsDialog = true"></tooltip-basic>
      </template>

      <v-btn icon @click="showContent = !showContent">
        <v-icon>{{ showContent ? upIcon : downIcon }}</v-icon>
      </v-btn>

      <v-progress-linear :active="isLoading" indeterminate absolute bottom>
      </v-progress-linear>
    </v-toolbar>

    <v-expand-transition>
      <div v-if="showContent">
        <template v-if="travel.isFeedbackExists()">
          <v-tabs v-model="tab" :grow="!$vuetify.breakpoint.xsOnly" :show-arrows="$vuetify.breakpoint.xsOnly">
            <!--          <v-tabs v-model="tab" show-arrows :grow="!$vuetify.breakpoint.xsOnly">-->
            <v-tab>
              <v-icon left>{{ infoIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.travelStats.toolbarTitle') }}
            </v-tab>

            <v-tab>
              <v-icon left>{{ starIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.userFeedback.travelRating') }}
            </v-tab>

            <v-tab-item>
              <v-card flat>
                <iconed-travel-stats :travel="travel" :raw-values="rawValues"
                                     :additional-statistics="additionalStatistics"></iconed-travel-stats>
              </v-card>

            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <user-feedback-view :drowsiness-feedback="travel.drowsinessFeedback.feedback"
                                    :aggressiveness-feedback="travel.aggressivenessFeedback.feedback">
                </user-feedback-view>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </template>
        <template v-else>
          <iconed-travel-stats :travel="travel" :raw-values="rawValues"
                               :additional-statistics="additionalStatistics"
                               :filters="additionalStatisticsFilters"
          ></iconed-travel-stats>
        </template>
      </div>
    </v-expand-transition>

    <confirmation-dialog :dialog="measurementsDialog"
                         :title="$vuetify.lang.t('$vuetify.map.travelStatsCard.measurementsDialog.title')"
                         :text="`<pre>${parsedMeasurements}</pre>`"
                         :is-reject="false"
                         :is-confirm="false"
                         @confirmation-dialog-closed="measurementsDialog = false">
    </confirmation-dialog>

    <server-requests-dialog :dialog="clientFilesDialog"
                            :file-data-request="fileDataRequest"
                            @close-server-requests-dialog="clientFilesDialog = false"
    ></server-requests-dialog>

    <sql-helper-dialog :dialog="sqlHelperDialog" @sql-helper-dialog-close="sqlHelperDialog = false"
                       :event="sqlHelperEvent" :user-id="this.travel.user.userId"></sql-helper-dialog>

  </v-card>
</template>

<script>
import {
  mdiChartBar,
  mdiDatabaseExport,
  mdiDownload,
  mdiFileMultiple,
  mdiInformationOutline,
  mdiStar,
  mdiTimer
} from '@mdi/js'
import UserFeedbackForm from '../userFeedback/userFeedbackForm'
import TextCopyPopup from '../../utils/textCopyPopup'
import IconedTravelStats from './iconedTravelStats'
import UserFeedbackView from '../userFeedback/userFeedbackView'
import { ComponentMode } from '@/enum'
import showContentMixin from '../../../mixins/showContentMixin'

import backend from '../../../backend'
import { TripAdditionalStatistics } from '@/models/travel/TripAdditionalStatistics'
import snackbarMixin from '../../../mixins/snackbarMixin'
import { AUTH_MODULE } from '@/store/modules'
import { createHelpers } from 'vuex-map-fields'
import { additionalTripStatisticsFilter, additionalTripStatisticsFilters } from '@/utils/travels'
import { RouteAdditionalStatistics } from '@/models/travel/RouteAdditionalStatistics'
import TooltipBasic from '@/components/utils/tooltipBasic'
import ConfirmationDialog from '@/components/utils/confirmationDialog'
import ServerRequestsDialog from '@/components/map/serverRequests/serverRequestsDialog'
import { FileDataRequest } from '@/models/serverRequests/FileDataRequest'
import { CriticalEvent } from '@/models/map/CriticalEvent'
import SqlHelperDialog from '@/components/utils/sqlHelperDialog'

const { mapFields: authFields } = createHelpers({
  getterType: `${AUTH_MODULE}/getField`
})

export default {
  name: 'travelStatsCard',
  components: {
    SqlHelperDialog,
    ServerRequestsDialog,
    ConfirmationDialog,
    TooltipBasic,
    UserFeedbackView,
    IconedTravelStats,
    TextCopyPopup,
    UserFeedbackForm
  },
  mixins: [showContentMixin(), snackbarMixin],
  props: {
    travel: Object,
    rawValues: Boolean
  },
  data: function () {
    return {
      tab: 0,
      isLoading: false,
      additionalStatistics: new TripAdditionalStatistics(),
      routeStatistics: new RouteAdditionalStatistics(),
      additionalStatisticsFilters: additionalTripStatisticsFilters,
      measurementsDialog: false,
      clientFilesDialog: false,
      sqlHelperDialog: false,
      fileDataRequest: new FileDataRequest({
        userId: this.travel.user.userId,
        after: this.travel.tempStart.getTime(),
        before: this.travel.tempFinish.getTime()
      }),

      barIcon: mdiInformationOutline,
      infoIcon: mdiChartBar,
      starIcon: mdiStar,
      loadIcon: mdiDownload,
      measurementsIcon: mdiTimer,
      clientFilesIcon: mdiFileMultiple,
      sqlIcon: mdiDatabaseExport
    }
  },
  computed: {
    ...authFields(['isSpecial', 'isAdmin', 'isDebugView']),
    parsedMeasurements () {
      let parsed = Object.keys(this.travel.measurements).length > 0 ? JSON.stringify(this.travel.measurements, null, 2) : '{}'
      return parsed
        .replace('"total_travel_fetch_time":',
          '<span class="font-weight-bold">"total_travel_fetch_time":</span>')
        .replace('"road_line":',
          '<span class="font-weight-bold">"road_line":</span>')
        .replace('"critical_events":',
          '<span class="font-weight-bold">"critical_events":</span>')
    },
    debugMode () {
      return (this.isAdmin || this.isDebugView) && this.rawValues
    },
    sqlHelperEvent () {
      // create fake event for events range
      return new CriticalEvent({
        datetimestart: this.travel.datetimestart,
        timeeventstart: this.travel.tempStart,
        timeeventend: this.travel.tempFinish
      })
    }
  },
  methods: {
    passFeedback (feedback) {
      this.$emit('feedback-passed', feedback)
    },
    async loadAdditionalStatistics () {
      this.isLoading = true
      try {
        const result = await backend.fetchTripAdditionalStatistics({
          datetimestart: this.travel.datetimestart.getTime(),
          user_id: this.travel.user.userId,
          filters: this.additionalStatisticsFilters
        })

        this.additionalStatistics = new TripAdditionalStatistics({ ...result.data.values })
        this.$emit('route-additional-statistics', result.data.routes)
      } catch (e) {
        console.error(e)
        this.openFailureSnackbar(`$vuetify.map.mapDialog.tripAdditionalStatisticsFailure`)
      } finally {
        this.isLoading = false
      }
    }
  },
  created () {
    this['ComponentMode'] = ComponentMode
  }
}
</script>

<style scoped>
.tab-left {
  justify-content: start;
}
</style>
